export default class MaturityRatingService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getSimpleList(params) {
		return this.apiService.callGet('maturityRatings/simple', params)
	}
}



// WEBPACK FOOTER //
// ./src/service/MaturityRatingService.js